import React from "react";
import { browserHistory } from "react-router";
import axios from "axios";
import logoImage from "../static/logo-payoff.svg";

export default class Header extends React.Component {
  constructor(props) {
    super(props);
  }

  handleLogout() {
    axios.get("/v1/auth/logout/");
    localStorage.clear();
    browserHistory.push("/");
  }

  render() {
    var loginTag = "";
    if (localStorage.loginToken !== undefined && localStorage.loginToken !== "invalid") {
      loginTag = (
        <a href="" onClick={this.handleLogout}>
          Uitloggen
        </a>
      );
    }

    return (
      <div className="site-header">
        <a href="/events">
          <img className="logo-payoff" src={logoImage} />
        </a>
        <span className="content-right">{loginTag}</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/Header.js